// src/components/Home/BlogSection.js
import React from "react";
import { motion } from "framer-motion";

const fadeUp = { hidden: { opacity: 0, y: 20 }, visible: { opacity: 1, y: 0 } };

export default function BlogSection({ blogs }) {
    return (
        <section className="py-20 bg-gray-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    {blogs.map((post, idx) => (
                        <motion.div
                            key={idx}
                            className="bg-white rounded-xl shadow-md overflow-hidden hover:shadow-xl transition"
                            initial={fadeUp.hidden}
                            whileInView={fadeUp.visible}
                            viewport={{ once: true }}
                            transition={{ duration: 0.5, delay: idx * 0.2 }}
                        >
                            <img src={post.image} alt={post.title} className="w-full h-48 object-cover" />
                            <div className="p-6">
                                <h3 className="text-xl font-semibold mb-2">{post.title}</h3>
                                <p className="text-gray-600 mb-4">{post.excerpt}</p>
                                <a
                                    href={post.link}
                                    className="text-red-600 font-semibold hover:underline"
                                >
                                    Xem chi tiết
                                </a>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
